<ng-container *ngIf="!loading; else loadingTemplate">
  <div
    class="d-flex flex-column flex-lg-row justify-content-center align-items-center mb-4">
    <div class="stat-box">
      <div class="qlabel">Average</div>
      <div class="data">
        @if(!nullAverage) {
        {{ average }}
        } @else { - }
      </div>
    </div>
    <div class="stat-box">
      <div class="qlabel">Median</div>
      <div class="data">
        @if(!nullMedian) {
        {{ median }}
        } @else { - }
      </div>
    </div>
    <div class="stat-box">
      <div class="qlabel">Range</div>
      <div class="data">
        @if(!nullRange) {
        {{ range }}
        } @else { - }
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <div class="w-100" style="height: 150px; position: relative">
    <app-loader></app-loader>
  </div>
</ng-template>
